export default __webpack_public_path__ + "static/media/4_ID.bada3041.png";